import { useMemo } from 'react';
import { makeItemSelector, useAppSelector } from '@wappsto/redux';

export default function useItemSelector(itemName: string) {
  const getItem = useMemo(() => makeItemSelector(), []);
  return useAppSelector(state => getItem(state, itemName));
}
